import { render, staticRenderFns } from "./editShipmentDoc.vue?vue&type=template&id=12db237a&scoped=true&"
import script from "./editShipmentDoc.vue?vue&type=script&lang=js&"
export * from "./editShipmentDoc.vue?vue&type=script&lang=js&"
import style0 from "./editShipmentDoc.vue?vue&type=style&index=0&id=12db237a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db237a",
  null
  
)

export default component.exports